<div
  data-id="quick-filters"
  class="flex gap-4 flex-wrap"
  *transloco="let t; scope: 'featureSearch'"
>
  @for (filterOption of filters; track filterOption.key) {
    @let label = (filterOption | translateDisplayText: 'label' | async) ?? '';
    <p-button
      [attr.data-id]="'quick-filter-tag-' + filterOption.key"
      label="{{ label }}{{
        !searchResultsCountsPerScopeLoading
          ? ' ' + searchResultsCountsPerScope.get(filterOption.key)
          : ''
      }}"
      icon="{{ filterOption.icon }}"
      styleClass="bd-filter-tag"
      [outlined]="true"
      (onClick)="applyFilter(filterOption)"
    />
  }
  <p-button
    data-id="more-filters"
    label="{{ t('featureSearch.moreFilters') }}"
    styleClass="bd-filter-tag bd-clear-filter-tag"
    [outlined]="false"
    (onClick)="showAdvancedFilter()"
  />
</div>
